import axios from 'axios'
import links from '../links.json'
// import { generateHMACSignature } from './helpers'
//
// const MSG_SERVICE_UNAVAILABLE = 'Fiscal printer is unavailable'
// const MSG_SERVICE_ERROR = 'Fiscal printer error'
// const MSG_SUCCESSFULLY_PRINTED = 'Printed'

// const formatErrorResponse = (err) => {
//   let message
//   if (err.status === 0) {
//     message = MSG_SERVICE_UNAVAILABLE
//   } else if (err.status === 200) {
//     message = MSG_SUCCESSFULLY_PRINTED
//   } else if (err.response?.data?.message) {
//     message = err.response.data.message
//   } else {
//     message = MSG_SERVICE_ERROR + ': ' + err.message
//   }
//
//   return {
//     success: false,
//     message
//   }
// }
//
// const formatSuccessResponse = (res) => {
//   return {
//     success: true,
//     message: res.data.message
//   }
// }

// const sendDataToPrinter = async (res) => {
//   const secretKey = import.meta.env.VITE_PRINTER_APP_KEY ?? ''
//   const signature = await generateHMACSignature(res.data, secretKey)
//
//   return axios.post(
//     'http://localhost:8989/api/send',
//     res.data,
//     {
//       headers: {
//         'X-Signature': signature,
//         'Content-Type': 'application/json'
//       }
//     }
//   )
//     .then(res => {
//       return formatSuccessResponse(res)
//     })
//     .catch(err => {
//       return formatErrorResponse(err)
//     })
// }

const prepareData = (data) => {
  return axios.post(
    links.application.fiscalPrinter.prepareData,
    data
  )
  // .then(res => {
  //   return sendDataToPrinter(res)
  // })
}

export const printReceiptPrepareData = (document) => {
  return prepareData({
    data: {
      document
    }
  })
}

export const printControlReport = () => {
  return prepareData({
    data: {
      dailyReportNoReset: true
    }
  })
}

export const printDailyClosing = () => {
  return prepareData({
    data: {
      dailyReportReset: true
    }
  })
}

export const printMoneyInput = (amount) => {
  return prepareData({
    data: {
      money_in_out_amount: parseInt(amount)
    }
  })
}

export const printMoneyOutput = (amount) => {
  return prepareData({
    data: {
      money_in_out_amount: parseInt(amount)
    }
  })
}

export const unblockReceipt = () => {
  return prepareData({
    data: {
      unblock: true
    }
  })
}

export const printShortReport = (dateFrom, dateTo) => {
  return prepareData({
    data: {
      shortReport: true,
      dateFrom,
      dateTo
    }
  })
}

export const printDetailedReport = (dateFrom, dateTo) => {
  return prepareData({
    data: {
      detailedReport: true,
      dateFrom,
      dateTo
    }
  })
}

export const updatePrinterDateTime = (dateTime) => {
  return prepareData({
    data: {
      updatePrinterDateTime: true,
      dateTime
    }
  })
}
